<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start" (click)="back()" text=""></ion-back-button>
    <ion-title *ngIf="!isSelect">Tags verwalten</ion-title>
    <ion-title *ngIf="isSelect">Tags auswählen</ion-title>
    <ion-buttons slot="end" *ngIf="authSrv.getUser().role.includes('access_settings')">
      <ion-button (click)="addTag()">
        <ion-icon slot="icon-only" name="fa-plus"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-searchbar placeholder="Suchen..." [(ngModel)]="searchText" (ngModelChange)="search()"></ion-searchbar>
  <ion-item *ngFor="let tag of tagsColored" (click)="editTag(tag)" style="--background: {{tag?.rgba}}">
    <div class="color" slot="start" [ngStyle]="{'background': tag?.hex}"></div>
    <ion-label>
      <h2>{{tag.description}}</h2>
    </ion-label>
    <ion-checkbox slot="end" *ngIf="isSelect" [checked]="isSelected(tag)" mode="ios"></ion-checkbox>
  </ion-item>

  @if(tagsColored.length === 0)  {
    <p class="no-content">Keine Tags vorhanden</p>
  }
  
</ion-content>
 